export enum GenderEnum {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}
